var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon",on:{"click":_vm.back}},[_c('van-icon',{staticClass:"arrow",attrs:{"name":"arrow-left"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }